import React, { Component } from "react";
import { Box } from "@material-ui/core";
import classes from "./Blog.module.css";

class Blog extends Component {

  
  render() {
    return (
        <>
      <Box ml={4} mt={2}>
        <p className={classes.sectionName}>BLOG</p>
        <hr></hr>
        <a href="https://yidi0213.github.io/blog" target="_blank" className={classes.link}> <h3>Blog Link</h3></a>
      </Box>
      </>
    );
  }
}

export default Blog;
